import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Stack, Typography, Button } from '@mui/material';
import AssetImage from '../../common/asset/AssetImage';
const Instructors = ({ instructors, showAvatar, size, instructorAction, }) => {
    if (!instructors) {
        return null;
    }
    // const instructorLink = (id) => (`instructor/${id}`);
    return (_jsx(Stack, { direction: "row", spacing: size === 'medium' ? 1 : 2, children: instructors.map((instructor) => (_jsx(Stack, { direction: "row", spacing: size === 'medium' ? 1 : 2, children: _jsxs(Button, { onClick: () => {
                    instructorAction(instructor.id);
                }, sx: {
                    textTransform: 'none',
                    padding: 0,
                }, children: [showAvatar && (_jsx(AssetImage, { customStyle: {
                            marginRight: '14px',
                            width: size === 'medium' ? 30 : 40,
                            height: size === 'medium' ? 30 : 40,
                            borderRadius: size === 'medium' ? 15 : 20,
                        }, asset: instructor.profileImage, size: "thumb400w" })), _jsx(Typography, { sx: {
                            marginX: '0 !important',
                            marginY: 'auto !important',
                        }, className: "instructor", children: instructor.name })] }) }, instructor.id))) }));
};
export default observer(Instructors);
//# sourceMappingURL=ItemInstructors.js.map